module.exports = __webpack_public_path__ + "static/media/kids_play_foot_ball_300.4f33a491.gif";